import ReusableSection from "../../components/common/ReusableSection";

const testimonialData = {
  header: {
    title: "Here Directly From our Farmers",
    description:
      "It is very important to choose the right method of fertilizer application. Produced by Asia's largest bio-gas plant Govardhannathji Energies LLP.",
    button: {
      text: "Order Now",
      onClick: () => console.log("Navigating to Order Page"),
    },
  },
  slides: [
    {
      image: "/assets/farmersImg.png",
      videoUrl: "/assets/farmer-video-1.mp4", // Naya dynamic field
      alt: "Farmer Testimonial 1",
    },
    {
      image: "/assets/farmersImg.png",
      videoUrl: "/assets/farmer-video-2.mp4", // Naya dynamic field
      alt: "Farmer Testimonial 2",
    },
    {
      image: "/assets/farmersImg.png",
      videoUrl: "/assets/farmer-video-2.mp4", // Naya dynamic field
      alt: "Farmer Testimonial 2",
    },
    {
      image: "/assets/farmersImg.png",
      videoUrl: "/assets/farmer-video-2.mp4", // Naya dynamic field
      alt: "Farmer Testimonial 2",
    },
  ],
  // You can pass custom options if you need different settings than the default
  // splideOptions: { perPage: 2, gap: '2rem' }
};

const TestimonialPage = () => {
  return (
    <main>
      <ReusableSection
        header={testimonialData.header}
        slides={testimonialData.slides}
        // splideOptions={customSplideOptions} // Uncomment if you have custom options
      />
      {/* You can now reuse ReusableSection for a Products Carousel or any other content */}
    </main>
  );
};

export default TestimonialPage;
